var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.3057 9.0741H10.6946C8.01087 9.0741 5.8335 11.2515 5.8335 13.9352V46.3426C5.8335 49.0264 8.01087 51.2037 10.6946 51.2037H30.1391L28.5187 56.0648H21.227C19.8801 56.0648 18.7965 57.1485 18.7965 58.4954C18.7965 59.8423 19.8801 60.9259 21.227 60.9259H48.7733C50.1202 60.9259 51.2039 59.8423 51.2039 58.4954C51.2039 57.1485 50.1202 56.0648 48.7733 56.0648H41.4816L39.8613 51.2037H59.3057C61.9895 51.2037 64.1668 49.0264 64.1668 46.3426V13.9352C64.1668 11.2515 61.9895 9.0741 59.3057 9.0741ZM57.6853 44.7222H12.315V15.5556H57.6853V44.7222Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.2672b11ca9f1a7ffaab737b2a4270987.svg";
export { ForwardRef as ReactComponent };